'use client';

import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';

type CollapsibleFilterProps = {
  children: React.ReactNode;
  title: string;
  defaultOpen?: boolean;
  className?: string;
};

export const CollapsibleFilter = ({
  children,
  title,
  defaultOpen = false,
  className,
}: CollapsibleFilterProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Collapsible
      className={cn('mb-4', className)}
      defaultOpen={defaultOpen}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <CollapsibleTrigger className='group/trigger flex w-full items-center justify-between py-2 font-medium'>
        <span className='text-brand-dark'>{title}</span>
        {isOpen ? (
          <ChevronUp className='size-4' />
        ) : (
          <ChevronDown className='size-4' />
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className='pt-2'>{children}</CollapsibleContent>
    </Collapsible>
  );
};
